import { sentryCreateBrowserRouter } from '@/lib/sentry.lib';

import { RouterError } from '@/components/router-error';
import RootLayout from '@/components/routes/root-layout/root-layout.component';
import { RouterNotFound } from '@/components/routes/router-not-found';

import { AssetView } from './components/routes/asset-view';
import { AssetsList } from './components/routes/assets-list';
import { BASE_URL } from './router-paths';

export const ROUTES = [
    {
        element: <RootLayout />,
        errorElement: <RouterError />,
        children: [
            {
                path: '*',
                element: <RouterNotFound />,
            },
            {
                path: BASE_URL,
                element: <AssetsList />,
            },
            {
                path: `${BASE_URL}/view/:assetType/:assetId`,
                element: <AssetView />,
            },
            {
                path: `${BASE_URL}/changelog`,
                lazy: async () => {
                    const { Changelog } = await import('@/components/routes/changelog');
                    return {
                        Component: Changelog,
                    };
                },
            },
        ],
    },
];

export const Router = sentryCreateBrowserRouter(ROUTES);
